import React from 'react';

const NoPageFound = () => {
    return (
        <div>
            <h3 className='my-5 text-center text-secondary'> 404! No Page Found</h3>
        </div>
    );
};

export default NoPageFound;